(function () {
  const PROCESSED_ATTR = 'data-mx-boost-processed';
  const cache = new Map(); // handle -> Promise<Document>

  function fetchSection(handle) {
    if (!cache.has(handle)) {
      const rootUrl = window.theme?.routes?.root === '/' ? '' : (window.theme?.routes?.root || '');
      cache.set(handle,
        fetch(`${rootUrl}/products/${encodeURIComponent(handle)}?sections=mx-boost-api`)
          .then(r => r.json())
          .then(data => new DOMParser().parseFromString(data['mx-boost-api'], 'text/html'))
          .catch(e => { cache.delete(handle); throw e; })
      );
    }
    return cache.get(handle);
  }

  // Clears placeholder, inserts el.outerHTML, removes hidden. Returns the inserted element.
  function insertElement(card, placeholderSel, el) {
    const placeholder = card.querySelector(placeholderSel);
    if (!placeholder || !el) return null;
    while (placeholder.firstChild) placeholder.removeChild(placeholder.firstChild);
    placeholder.insertAdjacentHTML('beforeend', el.outerHTML);
    placeholder.removeAttribute('hidden');
    return placeholder.firstElementChild;
  }

  // TIPA (5. 10. 2026): firma platící DPH má velkou a přeškrtnutou cenu BEZ DPH
  // a malou s DPH (snippets/price.liquid). Boost kreslí velkou cenu ze svého indexu
  // (s DPH), proto ji i přeškrtnutou přepíšeme hodnotami z motivu. Pozná se podle
  // .price__without-vat--gross v odpovědi sekce mx-boost-api. Ostatním se nic nemění.
  function applyNetPrices(card, doc) {
    const box = card.querySelector('.boost-sd__product-price');
    const main = doc.querySelector('.price__current .js-value');
    const mainText = main && main.textContent.replace(/\s+/g, ' ').trim();
    if (!box || !mainText) return;

    const mainEl = box.querySelector(
      '.boost-sd__product-price--sale .boost-sd__format-currency,' +
      '.boost-sd__product-price--default .boost-sd__format-currency'
    );
    if (!mainEl) return;   // neznámá podoba šablony – raději nechat celou cenu od Boostu
    const sr = box.querySelector('.boost-sd__visually-hidden');
    const oldMain = mainEl.textContent.trim();
    mainEl.textContent = mainText;
    if (sr && oldMain) sr.textContent = sr.textContent.replace(oldMain, mainText);

    const was = doc.querySelector('.price__was .js-value');
    const wasText = was && was.textContent.replace(/\s+/g, ' ').trim();
    const cmp = box.querySelector('.boost-sd__product-price--compare');
    const cmpEl = cmp && cmp.querySelector('.boost-sd__format-currency');
    if (cmpEl) {
      const oldWas = cmpEl.textContent.trim();
      if (wasText) {
        cmpEl.textContent = wasText;
        if (sr && oldWas) sr.textContent = sr.textContent.replace(oldWas, wasText);
      } else {
        cmp.hidden = true;
      }
    }
    box.setAttribute('data-tipa-net', '1');
  }

  // Adds boost stock class to el (or a descendant matched by childSel) based on data-inventory-level.
  function applyStockClass(el, childSel) {
    const target = childSel ? el?.querySelector(childSel) : el;
    if (!target) return;
    target.classList.add(
      target.dataset.inventoryLevel === 'normal'
        ? 'boost-sd__inventory-status--in-stock'
        : 'boost-sd__inventory-status--low-stock'
    );
  }

  async function processCard(card) {
    let data = null;
    if (card.dataset.product) {
      try {
        data = JSON.parse(card.dataset.product);
      } catch (e) {
        // Boost sometimes injects unescaped characters (e.g. inch marks in titles) that
        // break JSON.parse. Fall back to a regex extraction of the handle so the section
        // fetch can still run and enrich the card.
        const handleMatch = card.dataset.product?.match(/"handle"\s*:\s*"([^"]+)"/);
        if (handleMatch) {
          data = { handle: handleMatch[1] };
        } else {
          console.error('Failed to parse product data for Boost card:', e, card.dataset.product);
        }
      }
    }

    const handle = data?.handle || card.dataset.productHandle;
    if (!handle) return;

    const doc = await fetchSection(handle);

    applyStockClass(insertElement(card, '.mx-inventory-status-placeholder', doc.querySelector('.mx-inventory-status')));
    applyStockClass(insertElement(card, '.mx-shipping-date-placeholder', doc.querySelector('.mx-shipping-date')), '.shipping-date__date');
    insertElement(card, '.mx-without-vat-price-placeholder', doc.querySelector('.price__without-vat'));
    if (doc.querySelector('.price__without-vat--gross')) applyNetPrices(card, doc);

    const badgesWrapper = doc.getElementById('mx-boost-badges-html');
    const badgesPlaceholder = card.querySelector('.mx-product-badges-placeholder');
    if (badgesWrapper && badgesPlaceholder) {
      while (badgesPlaceholder.firstChild) badgesPlaceholder.removeChild(badgesPlaceholder.firstChild);
      badgesPlaceholder.insertAdjacentHTML('beforeend', badgesWrapper.innerHTML);
      badgesPlaceholder.removeAttribute('hidden');
    }

    const gtmItemScript = doc.getElementById('mx-boost-gtm-item');
    if (gtmItemScript) {
      card.dataset.gtmItem = gtmItemScript.textContent.trim();
    }

    document.dispatchEvent(new CustomEvent('on:boost:card:update', {
      bubbles: true,
      detail: {
        productId: card.dataset.productId
      }
    }))
  }

  // Preload card images shortly before they scroll into view so the grid never shows
  // a blank space. Boost renders card images with native loading="lazy", which only
  // starts the download once the image reaches the viewport edge — switching to
  // "eager" while the card is still within the preload margin starts it early.
  const imageObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.querySelectorAll('img[loading="lazy"]').forEach(img => { img.loading = 'eager'; });
          obs.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px 800px 0px' })
    : null;

  function preloadImagesEarly(card) {
    if (imageObserver) {
      imageObserver.observe(card);
    } else {
      card.querySelectorAll('img[loading="lazy"]').forEach(img => { img.loading = 'eager'; });
    }
  }

  function processAll() {
    document.querySelectorAll(
      `.boost-sd__product-item:not([${PROCESSED_ATTR}]),` +
      `.boost-pfs-filter-product-item:not([${PROCESSED_ATTR}])`
    ).forEach(card => {
      card.setAttribute(PROCESSED_ATTR, 'true');
      preloadImagesEarly(card);
      processCard(card).catch(e => console.error('Failed to process Boost card:', e));
    });
  }

  // Recover the UI when a Boost add-to-cart request fails or stalls (event
  // dispatched by the fetch observer in gtm-tracking-cart-monitoring.js).
  // Boost's own JS leaves its button stuck on the "Adding..." label with the
  // cart drawer spinner running forever: restore the button label (the
  // original text lives in aria-label), re-render the drawer and tell the
  // customer to try again.
  document.addEventListener('on:mx:cart-add:error', (event) => {
    if (event.detail?.source !== 'boost') return;

    document.querySelectorAll('.boost-sd__button--select-option').forEach(btn => {
      const label = btn.getAttribute('aria-label');
      if (label && btn.textContent.trim() !== label) btn.textContent = label;
    });

    document.querySelector('cart-drawer')?.refresh?.(true);
    alert(window.theme?.strings?.cartError || 'Error updating the cart. Please try again.');
  });

  const observer = new MutationObserver(processAll);
  observer.observe(document.body, { childList: true, subtree: true });
  processAll();
})();
